import React from 'react';
import css from './Loader.css'; // Import the external CSS file for styling

const Loader = () => {
  return (
    <div className={css.loaderContainer}>
      <div className={css.loader}></div>
    </div>
  );
};

export default Loader;